import React from 'react';

import { TableRow, TableCell, TableHead } from '@mui/material';

export const StudentTableHeader: React.FC = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Student Name</TableCell>
        <TableCell>Username</TableCell>
        <TableCell>Password</TableCell>
        <TableCell>License Status</TableCell>
      </TableRow>
    </TableHead>
  );
};
